import { Bot, User } from "lucide-react";
import ReactMarkdown from "react-markdown";
import type { Msg } from "./types";

interface ChatMessageProps {
  message: Msg;
}

const ChatMessage = ({ message: m }: ChatMessageProps) => (
  <div className={`flex gap-2.5 ${m.role === "user" ? "justify-end" : "justify-start"}`}>
    {m.role === "assistant" && (
      <div className="w-7 h-7 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
        <Bot className="w-4 h-4 text-primary" />
      </div>
    )}
    <div
      className={`max-w-[80%] rounded-lg px-3.5 py-2.5 text-sm leading-relaxed ${
        m.role === "user"
          ? "bg-primary text-primary-foreground rounded-br-sm"
          : "bg-muted text-foreground rounded-bl-sm"
      }`}
    >
      {m.role === "assistant" ? (
        <div className="prose prose-sm max-w-none dark:prose-invert prose-p:my-1 prose-li:my-0.5 prose-headings:my-2">
          <ReactMarkdown
            components={{
              a: ({ href, children }) => (
                <a href={href} target="_blank" rel="noopener noreferrer" className="text-primary underline hover:text-primary/80">
                  {children}
                </a>
              ),
            }}
          >{m.content}</ReactMarkdown>
        </div>
      ) : (
        m.content
      )}
    </div>
    {m.role === "user" && (
      <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center shrink-0 mt-0.5">
        <User className="w-4 h-4 text-muted-foreground" />
      </div>
    )}
  </div>
);

export default ChatMessage;
